import { useEffect, useState } from 'react';

function calculateTimeLeft(target) {
  const difference = target - Date.now();
  if (difference > 0) {
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }
  return null;
}

export default function Countdown({ targetDate }) {
  // Empty until mounted, so the page drawn at build time doesn't carry the
  // time that was left at build time.
  const [timeLeft, setTimeLeft] = useState(null);
  const target = +targetDate;

  useEffect(() => {
    const update = () => setTimeLeft(calculateTimeLeft(target));
    update();
    const timer = setInterval(update, 1000);

    return () => clearInterval(timer);
  }, [target]);

  if (!timeLeft) {
    return <span></span>;
  }

  return (
    <div>
      {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
    </div>
  );
}
